import { Object3D as i, Vector3 as p, Quaternion as a } from "three";
import { RoundArray as m } from "../../utils/array/index4.js";
import { getObject3D as d } from "./index10.js";
import { QuaternionToDegrees as c } from "./index19.js";
function y(o, n) {
  const t = o.map((r) => d(r)), e = new i();
  e.add(...t), e.copy(n), e.updateMatrixWorld();
  for (let r = 0; r < o.length; r++)
    o[r].pos = m(t[r].getWorldPosition(new p()).toArray()), o[r].rot = c(t[r].getWorldQuaternion(new a()));
  return o;
}
export {
  y as rgApplyTransform
};
//# sourceMappingURL=index23.js.map
